export class PharmacyCRUDModel {
  public PharmacyId: string;
  public PharmacyName: string;
  public EffectiveDate: string;
  public TermDate: string;
  public IsEnabled: string;
  public PetEnabled: string;
  public BillingGroup:string;
  public BillingRegion:string;
  public PharmacyEndpointURL: string;
  public OktaMckClientId:string;
  public AuthType: string;
  public OktaAuthURL: string;
  public OktaClientId: string;
  public OktaClientSecret: string;
  public HiddenClientSecret: string;
  public BasicUserName: string;
  public BasicPassword: string;
  public HiddenPassword: string;
  public PID: string;
  public UpdateDate:string;
  public UpdatedBy:string;
  public NCPDPIDs:PharmacyStoreGridData;
  public VendorId: number;
  public IsConnectivitySet:String;
  public IsVendorConnectionEnabled: string;
}
export class PharmacyStoreCRUDModel {
    public NCPDPID: String;
}
export class PharmacyStoreGridData{
    public TotalNumberOfRecords :number;
    public NCPDPIDs :PharmacyCRUDModel[];

  }
  export class PharmacyStoreGridDataMapper{
    mapToModel(json: any): PharmacyStoreGridData {
      let pharmacyStoreGridData: PharmacyStoreGridData = null;
      if (json) {
        pharmacyStoreGridData = new PharmacyStoreGridData();
        pharmacyStoreGridData.NCPDPIDs = json;
      }
      return pharmacyStoreGridData;
    }
  }

export class PharmacyCRUDResultModel {
  public Errors: Array<ErrorListItem>;
  public ResponseData: string;
  public ResponseMessage: string;
  public ResponseStatus: string;
}

export class ErrorListItem {
  public ErrorCode: number;
  public ErrorMessage: string;
}

export class PharmacyLookupDataMapper
{
  mapToModel(json: any): PharmacyCRUDModel {
    let pharmacyLookupData: PharmacyCRUDModel = null;
    let pharmacyStoreGridDataMapper=new PharmacyStoreGridDataMapper();
    if (json && json.ResponseData) {
      pharmacyLookupData = new PharmacyCRUDModel();
      pharmacyLookupData.PharmacyId=json.ResponseData.PharmacyId;
      pharmacyLookupData.PharmacyName=json.ResponseData.PharmacyName;
      pharmacyLookupData.EffectiveDate=json.ResponseData.EffectiveDate;
      pharmacyLookupData.TermDate=json.ResponseData.TermDate;
      pharmacyLookupData.IsEnabled=json.ResponseData.IsEnabled;
      pharmacyLookupData.PetEnabled=json.ResponseData.PetEnabled;
      pharmacyLookupData.BillingGroup=json.ResponseData.BillingGroup;
      pharmacyLookupData.BillingRegion=json.ResponseData.BillingRegion;
      pharmacyLookupData.PharmacyEndpointURL=json.ResponseData.PharmacyEndpointURL;
      pharmacyLookupData.OktaMckClientId=json.ResponseData.OktaMckClientId;
      pharmacyLookupData.AuthType=json.ResponseData.AuthType;
      pharmacyLookupData.OktaAuthURL=json.ResponseData.OktaAuthURL;
      pharmacyLookupData.OktaClientId=json.ResponseData.OktaClientId;
      pharmacyLookupData.OktaClientSecret="";
      pharmacyLookupData.HiddenClientSecret=json.ResponseData.OktaClientSecret;
      pharmacyLookupData.BasicUserName=json.ResponseData.BasicUserName;
      pharmacyLookupData.BasicPassword="";
      pharmacyLookupData.HiddenPassword=json.ResponseData.BasicPassword;
      pharmacyLookupData.PID=json.ResponseData.PID;
      pharmacyLookupData.NCPDPIDs=pharmacyStoreGridDataMapper.mapToModel(json.ResponseData.NCPDPIDs);
      pharmacyLookupData.VendorId=json.ResponseData.VendorId;
      pharmacyLookupData.IsVendorConnectionEnabled = json.ResponseData.IsVendorConnectionEnabled;
      pharmacyLookupData.IsConnectivitySet = json.ResponseData.IsConnectivitySet;
    }
    return pharmacyLookupData;
  }
}
